import { getDateTimeFormatter } from '@fe/core';
import { GDFWmoVolcano2Record } from '../../../gdf/type';

export default function WmoVolcano2Tooltip({ record }: { record: GDFWmoVolcano2Record }) {
    const formatter = getDateTimeFormatter();
    return (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content auto', columnGap: '1rem' }}>
                <div>DTG:</div>
                <div>{formatter.formatDateTime(record.reportTime) || '-'}</div>

                <div>Volcano:</div>
                <div>{record.name || '-'}</div>

                <div>Summit elevation:</div>
                <div>
                    {record.summit !== null && (
                        <span>
                            {Math.round(record.summit * 3.2808399).toLocaleString('en-US')}ft/{record.summit.toLocaleString('en-US')}m
                        </span>
                    )}
                    {record.summit === null && <span>-</span>}
                </div>

                <div>Advisory number:</div>
                <div>{record.advisory || '-'}</div>

                <div>Eruption details:</div>
                <div>{record.details || '-'}</div>

                <div>Next advisory</div>
                <div>{formatter.formatDate(record.nextReportTime) || 'Unknown'}</div>
            </div>
        </div>
    );
}
